import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
    const { t } = useTranslation('common');

    return (
        <div className="login">
            <Container>
                <h2>{t('notFound.title', {ns: 'common' })}</h2>
                <p>{t('notFound.message', { ns: 'common' })}</p>
                <div className="btn-box">
                    <Link to="/" className="btn">{t('toStartPage', { ns: 'common' })}</Link>
                </div>
            </Container>
        </div>
    );
}

export default NotFound;
